export default [
  {
    path: '/main/reportroteirizations',
    meta: {
      tag: 'report_roteirizations',
      name: 'Relatório de Roteirizações',
      breadcrumb: 'Relatório de Roteirizações'
    },
    component: () => import(/* webpackChunkName: "report-roteirizations" */ '@/views/main/reports/roteirizations/Index.vue'),
    children: [
      {
        path: '',
        name: 'listroteirizations',
        meta: {
          tag: 'report_roteirizations',
          name: 'Relatório de Roteirizações',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-roteirizations" */ '@/views/main/reports/roteirizations/List.vue'),
      }
    ]
  }
]
